import ArrowBack from "material-ui-icons/ArrowBack";
import ChevronLeft from "material-ui-icons/ChevronLeft";
import logger from "./logger";
import { saveAs } from "file-saver";
import { getBlob } from "./request";

const BackButtonIcon = () => {
    try {
        if (isCordova() && cordova.platformId === "ios") {
            return ChevronLeft;
        }
        return ArrowBack;
    } catch (e) {
        return ArrowBack;
    }
};

const BackButtonStyles = () => {
    try {
        if (isCordova() && cordova.platformId === "ios") {
            return { width: "1.5em", height: "1.5em" };
        }
        return { width: "1em", height: "1em" };
    } catch (e) {
        return { width: "1em", height: "1em" };
    }
};

const isCordova = () => {
    try {
        if (Boolean(window.cordova)) {
            return true;
        }
        return false;
    } catch (err) {
        logger.error(err);
        return false;
    }
};

export function getDeviceId() {
    if (isCordova()) {
        if (device) {
            return device.uuid as string;
        }
        return "";
    }
    return "";
}

export const BackIcon = BackButtonIcon();
export const BackButtonStyle = BackButtonStyles();
export const IsCordova = isCordova();

export async function downloadAndSaveFile(url: string, filename: string, mimeType: string): Promise<void> {
    try {
        const blob = await getBlob(url);
        saveBlob(blob, filename, mimeType);
    } catch (error) {
        logger.error(`Failed to download file ${url}`, error);
    }
}

export function saveBlob(blob: Blob, filename: string, mimeType: string): void {
    if (IsCordova && window.cordova.platformId !== "browser") {
        logger.info(`Saving file ${filename} ${mimeType} on device`);

        const storageLocation = cordova.file.dataDirectory;

        window.resolveLocalFileSystemURL(storageLocation, (dir: DirectoryEntry) => {

            dir.getFile(filename, {
                create: true,
                exclusive: false,
            }, (fileEntry) => {

                fileEntry.createWriter((writer) => {

                    writer.onwriteend = () => {
                        const url = fileEntry.toURL();
                        logger.log(`successfully wrote ${filename} to ${url}`);

                        cordova.plugins.fileOpener2.open(url, mimeType, {
                            success: () => {
                                logger.log("opened successfully %s", url);
                            },
                            error: () => {
                                logger.log("failed to open %s", url);
                            },
                        });
                    };

                    writer.onerror = () => {
                        logger.error(`error writing ${filename}`);
                    };

                    writer.write(blob);

                }, handleFileError);

            }, handleFileError);

        }, handleFileError);
    } else {
        logger.info(`Saving file ${filename} ${mimeType} inside browser`);
        saveAs(blob, filename);
    }
}

function handleFileError(error: FileError): void {
    logger.error(`FileError`, JSON.stringify(error, undefined, 2));
}



// WEBPACK FOOTER //
// ./src/util/platformUtils.ts